export const BASE_API_URL = 'https://gabebennett.com/wp/wp-json/wp/v2/'
